import { ADD_SIDEBAR_DETAILS } from "./sidebarTypes"

export const addSidebarDetails = (payload)=>{
    return{
        type:ADD_SIDEBAR_DETAILS,
        payload:payload
    }
}